import css from 'styled-jsx/css';

const styles = css`:root {
    /* @TODO get a hold of/unify these colors...
       tell design to stop giving us a new color palatte
       with each new design...
    */

    /* New II Design Pattern - Introduced 11-12-2019 */
    /* TODO: --grey-800 is the color for primary text and should be used throughout the entire application */
}
:root {

    /* Margin and padding should be in multiples of 8 (i.e.---8, 16, 24) */

    /* New II Design Pattern - Introduced 11-12-2019 */
}
:root {

    /* New II Design Pattern - Introduced 11-12-2019 */
}
/* @import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css'; */
.title-group {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
}
.title-group .buttons {
    padding-bottom: 8px;
}
.tables {
    width: 100%;
    margin-top: 10px;
}
.tables:before {
    content: '';
    display: table;
}
.tables:after {
    content: '';
    display: table;
    clear: both;
}
.tables :global(.t-header) {
    white-space: nowrap;
}
.column {
    width: calc(99.9% * 1/2 - (24px - 24px * 1/2));
}
.column:nth-child(1n) {
    float: left;
    margin-right: 24px;
    clear: none;
}
.column:last-child {
    margin-right: 0;
}
.column:nth-child(2n) {
    margin-right: 0;
    float: right;
}
.column:nth-child(2n + 1) {
    clear: both;
}
.disclaimer {
    margin-top: calc(24px / 2);
  font-size: 12px;
  font-weight: 400;
  color: #111111;
}
.view-all {
    margin-top: calc(24px / 2);
    display: block;
    color: #054c70;
    font-size: 14px;
  font-family: 'Nimbus Sans', sans-serif;
  font-weight: 400;
  font-style: normal;
    text-decoration: none;
}
.captions {
    display: flex;
}
.captions .as-of {
    flex: 1;
    text-align: right;
}
.top-10-bond-no-data {
  text-align: center;
  font-size: 20px;
}
@media (max-width: 720px) {
    .title-group .title {
        width: 50%;
    }

    .tables :global(.t-header) {
        white-space: normal;
        word-break: break-word;
        max-width: 240px;
    }
}
`;

export default styles;